{
  "roomFeatures": [
    {
      "id": "5",
      "param": "roomFeatures",
      "label": "Wi-Fi",
      "tooltip": "Available throughout the venue"
    },
    {
      "id": "12",
      "param": "roomFeatures",
      "label": "Music speakers / PA system",
      "tooltip": "Free or for a fee",
      "infoTooltip": "A PA system is an audio setup \ndesigned to amplify sound, \nensuring clear music and \nannouncements for events"
    },
    {
      "id": "8",
      "param": "roomFeatures",
      "label": "Projector",
      "tooltip": "Free or for a fee"
    },
    {
      "id": "19",
      "param": "roomFeatures",
      "label": "Quiet space"
    },
    {
      "id": "9",
      "param": "roomFeatures",
      "label": "Flatscreen TV",
      "tooltip": "Free or for a fee"
    },
    {
      "id": "6",
      "param": "roomFeatures",
      "label": "Natural light",
      "tooltip": "Window and/or skylight that provides sunlight"
    },
    {
      "id": "11",
      "param": "roomFeatures",
      "label": "Flipchart",
      "tooltip": "Free or for a fee"
    },
    {
      "id": "7",
      "param": "roomFeatures",
      "label": "Air conditioning",
      "tooltip": ""
    },
    {
      "id": "10",
      "param": "roomFeatures",
      "label": "Whiteboard",
      "tooltip": "Free or for a fee"
    },
    {
      "id": "16",
      "param": "roomFeatures",
      "label": "Storage space",
      "tooltip": "Place where clients can store items during their event"
    },
    {
      "id": "13",
      "param": "roomFeatures",
      "label": "Conference call facilities",
      "tooltip": "Teleconferencing facilities"
    },
    {
      "id": "21",
      "param": "roomFeatures",
      "label": "Photo equipment",
      "tooltip": "Camera and photography equipment available"
    },
    {
      "id": "22",
      "param": "roomFeatures",
      "label": "Video equipment",
      "tooltip": "Video recording equipment available"
    },
    {
      "id": "23",
      "param": "roomFeatures",
      "label": "Greenscreen",
      "tooltip": "Green screen for filming and photography"
    },
    {
      "id": "24",
      "param": "roomFeatures",
      "label": "Backdrops",
      "tooltip": "Photography backdrops available"
    },
    {
      "id": "25",
      "param": "roomFeatures",
      "label": "Dance floor",
      "tooltip": "Dedicated dance floor area"
    },
    {
      "id": "26",
      "param": "roomFeatures",
      "label": "Soundproof",
      "tooltip": "Soundproofed room for noise control"
    },
    {
      "id": "27",
      "param": "roomFeatures",
      "label": "Mirrors",
      "tooltip": "Full-length mirrors available"
    },
    {
      "id": "28",
      "param": "roomFeatures",
      "label": "Lighting equipment",
      "tooltip": "Professional lighting equipment for photography and filming"
    }
  ],
  "allowedEvents": [
    {
      "id": "17",
      "param": "roomFeatures",
      "label": "Play your own music"
    },
    {
      "id": "18",
      "param": "roomFeatures",
      "label": "Bring your own DJ"
    },
    {
      "id": "13",
      "param": "allowedEvents",
      "label": "Promoted / ticketed events",
      "tooltip": "Events that you’re promoting or selling tickets for"
    },
    {
      "id": "3",
      "param": "roomFeatures",
      "label": "Wedding licence",
      "tooltip": "Venue is licensed to host wedding ceremonies and receptions"
    }
  ],
  "accessibilityFeatures": [
    {
      "id": "wheelchairAccessible",
      "param": "accessibilityFeatures",
      "label": "Wheelchair accessible"
    },
    {
      "id": "disabledToilets",
      "param":  "accessibilityFeatures",
      "label": "Accessible toilets"
    },
    {
      "id": "groundLevel",
      "param":  "accessibilityFeatures",
      "label": "Step-free guest entrance"
    },
    {
      "id": "disabledParking",
      "param":  "accessibilityFeatures",
      "label": "Accessible parking spot"
    },
    {
      "id": "liftAllFloors",
      "param":  "accessibilityFeatures",
      "label": "Lift to all floors"
    },
    {
      "id": "cargoLift",
      "param":  "accessibilityFeatures",
      "label": "Cargo lift"
    }
  ],
  "venueFeatures": [
    {
      "id": "parking",
      "param": "venueFeatures",
      "label": "Parking available",
      "tooltip": "On-site parking facilities"
    },
    {
      "id": "accommodation",
      "param": "venueFeatures",
      "label": "Accommodation available",
      "tooltip": "On-site accommodation"
    }
  ],
  "christmasDiningEventTypes": [
    "private-dining",
    "dining-party",
    "banquet",
    "banqueting-hall",
    "restaurant"
  ],
  "christmasEventTypes": [
    "party",
    "event-venue",
    "function-room",
    "private-party",
    "corporate-event",
    "private-dining",
    "pub",
    "boat",
    "minimum-spend-venues",
    "bar-venues",
    "party-bus",
    "unusual-space",
    "office-party",
    "restaurant",
    "live-music",
    "luxury-venues",
    "nightclub-hire",
    "drinks-reception",
    "garden",
    "gala-dinner",
    "banquet",
    "banqueting-hall",
    "corporate-party",
    "blank-canvas",
    "railway-arch",
    "hall",
    "penthouse",
    "outdoor",
    "away-day-venues",
    "ball",
    "church",
    "clubbing",
    "dining-party",
    "dry-hire",
    "gallery"
  ],
  "cateringOptions": [
    {
      "id": "1",
      "label": "Venue offers catering",
      "tooltip": "Venue can organise food and drink"
    },
    {
      "id": "8",
      "label": "Venue provides alcohol",
      "tooltip": "Venue can supply alcoholic beverages"
    },
    {
      "id": "16",
      "label": "External catering allowed",
      "tooltip": "Bring your own food or hire a caterer of your choice"
    },
    {
      "id": "7",
      "label": "BYO alcohol allowed",
      "tooltip": "You can bring your own alcohol (corkage fee may apply)"
    },
    {
      "id": "1001",
      "label": "No buyout fee for external catering"
    },
    {
      "id": "1000",
      "label": "No corkage fee for BYO alcohol"
    },
    {
      "id": "18",
      "label": "Kitchen facilities available for guests",
      "tooltip": "Space where you can prepare food"
    },
    {
      "id": "20",
      "type": "menu",
      "label": "Vegetarian menu"
    },
    {
      "id": "14",
      "type": "menu",
      "label": "Vegan menu"
    },
    {
      "id": "2",
      "type": "menu",
      "label": "Halal menu"
    },
    {
      "id": "15",
      "type": "menu",
      "label": "Gluten-free menu"
    },
    {
      "id": "3",
      "type": "menu",
      "label": "Kosher menu"
    },
    {
      "id": "21",
      "type": "menu",
      "label": "Free refreshments",
      "infoTooltip": "Complimentary water, tea, \nand coffee provided for \nguests at no additional cost"
    }
  ],
  "styleOptions": [
    { "id": 234, "param": "roomTags", "label": "Modern" },
    { "id": 201, "param": "roomTags", "label": "Luxury" },
    { "id": 143, "param": "roomTags", "label": "Unusual" },
    { "id": 308, "param": "roomTags", "label": "Industrial" },
    { "id": 309, "param": "roomTags", "label": "Vintage" },
    { "id": 307, "param": "roomTags", "label": "Colorful" },
    { "id": 306, "param": "roomTags", "label": "View" },
    { "id": 305, "param": "roomTags", "label": "Waterfront" }
  ],
  "LOUD_EVENTS_ID": "20",
  "weddingLicenseId": "3",
  "temporaryEventNoticesId": "4"
}
